import Component from 'flarum/common/Component';
import Button from 'flarum/common/components/Button';
import { t, text } from '../helpers';
import BsiIcon from './BsiIcon';
import EcuHousing from './EcuHousing';
import HeroStage from './HeroStage';
const units = ['ecu', 'tcu'];

// The unit picker explains the illustration; it is independent of order forms.
// Pointer perspective and decorative animation respect reduced motion.
export default class HeroArtwork extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
    this.pointer = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.frame = null;
    this.unit = 'ecu';
  }
  onremove(vnode) {
    window.cancelAnimationFrame(this.frame);
    super.onremove(vnode);
  }
  move(event) {
    if (this.motion.matches || !this.pointer.matches || event.pointerType !== 'mouse') return;
    this.point = {
      x: event.clientX,
      y: event.clientY
    };
    if (this.frame !== null) return;
    this.frame = window.requestAnimationFrame(() => {
      this.frame = null;
      const box = this.element.getBoundingClientRect();
      const x = Math.max(-1, Math.min(1, (this.point.x - box.left) / box.width * 2 - 1));
      const y = Math.max(-1, Math.min(1, (this.point.y - box.top) / box.height * 2 - 1));
      this.element.style.setProperty('--bsi-tilt-x', `${-y * 5}deg`);
      this.element.style.setProperty('--bsi-tilt-y', `${x * 7}deg`);
      this.element.style.setProperty('--bsi-stage-x', `${-x * 5}px`);
      this.element.style.setProperty('--bsi-stage-y', `${-y * 3}px`);
    });
  }
  reset() {
    window.cancelAnimationFrame(this.frame);
    this.frame = null;
    this.element.style.removeProperty('--bsi-tilt-x');
    this.element.style.removeProperty('--bsi-tilt-y');
    this.element.style.removeProperty('--bsi-stage-x');
    this.element.style.removeProperty('--bsi-stage-y');
  }
  view() {
    return m("div", {
      className: "BsiHeroArt",
      onpointermove: event => {
        event.redraw = false;
        this.move(event);
      },
      onpointerleave: event => {
        event.redraw = false;
        this.reset();
      }
    }, m("div", {
      "aria-hidden": "true"
    }, m(HeroStage, null), m("div", {
      className: "BsiHeroArt-depth"
    }, m(EcuHousing, {
      unit: this.unit
    }), m("div", {
      className: "BsiHeroArt-file"
    }, m(BsiIcon, {
      name: "file-code"
    }), m("span", null, t('home.file_label')), m("span", {
      className: "BsiHeroArt-check"
    }, m(BsiIcon, {
      name: "check"
    }))))), m("div", {
      className: "BsiUnitPicker"
    }, m("div", {
      className: "BsiUnitPicker-options",
      role: "group",
      "aria-label": text('home.unit_selector'),
      style: {
        '--bsi-active-unit': units.indexOf(this.unit)
      }
    }, units.map(unit => m(Button, {
      key: unit,
      className: 'Button BsiUnitPicker-option' + (this.unit === unit ? ' is-selected' : ''),
      "aria-pressed": this.unit === unit ? 'true' : 'false',
      title: text('home.unit_' + unit + '_description'),
      onclick: () => {
        this.unit = unit;
      }
    }, t('home.unit_' + unit)))), m("p", {
      id: "bsi-unit-caption",
      className: "BsiUnitPicker-caption",
      "aria-live": "polite",
      "aria-atomic": "true"
    }, t('home.unit_' + this.unit + '_description'))));
  }
}
flarum.reg.add('bsi-orders', 'forum/components/HeroArtwork', HeroArtwork);